export default "__VITE_ASSET__D8Hx6o6G__"